



















import { defineComponent, computed } from '@vue/composition-api';
export default defineComponent({
  props: {
    offset: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  emits: {
   'offset-change': (offset: number) => offset >= 0
  },
  setup(props, context) {

    const currentPage = computed(() => {
      return Math.floor(props.offset / props.limit);
    });
    const maxPages = computed(() => {
      return Math.ceil(props.total / props.limit);
    });

    const elems = computed(() => {

      const vals: Array<number|undefined> = [];
      for(let i = 0; i < maxPages.value; ++i) {

        if(i === 0) {
          vals.push(i);
        }
        else if(i === maxPages.value - 1) {
          vals.push(i);
        }
        else if(maxPages.value - i < 3 && maxPages.value - currentPage.value < 3) {
          vals.push(i);
        }
        else if(i < 3 && currentPage.value < 3) {
          vals.push(i);
        }
        else {
          if(Math.abs(i - currentPage.value) > 2) {
            if(vals[vals.length - 1] !== undefined) {
              vals.push(undefined);
            }
          }
          else {
            vals.push(i);
          }
        }
      }
      return vals;
    });

    const onClick = (index: number) => {
      
      if(index < elems.value.length) {

        const val = elems.value[index];
        
        if(val !== undefined) {
          context.emit('offset-change', val * props.limit);
        }
        else {
          const pageNrBefore: number = elems.value[index - 1] as number;
          const pageNrAfter: number = elems.value[index + 1] as number;
          const pageNr =  Math.floor((pageNrBefore + pageNrAfter) / 2);

          context.emit('offset-change', pageNr * props.limit);
        }
      }
    }

    return {
      elems,
      onClick,
      currentPage,
      maxPages
    }

  }

});
